import { get, post } from '../../shared/apiClient';

export interface PaymentConfig {
  publishable_key: string;
  payment_enabled: boolean;
}

export interface CreatePaymentIntentRequest {
  session_id: string;
}

export interface CreatePaymentIntentResponse {
  client_secret: string;
  amount_cents: number;
  currency: string;
  quote: {
    total_eur: number;
    breakdown: Record<string, string>;
  };
  payment_intent_id: string;
  already_paid: boolean;
}

export async function fetchPaymentConfig(): Promise<PaymentConfig> {
  const { data } = await get<PaymentConfig>('/payment/config');
  return data;
}

export async function createPaymentIntent(
  session_id: string
): Promise<CreatePaymentIntentResponse> {
  const { data } = await post<CreatePaymentIntentRequest, CreatePaymentIntentResponse>(
    '/payment/create-intent',
    { session_id }
  );
  return data;
}